import { render, staticRenderFns } from "./AvatarWrapper.vue?vue&type=template&id=cc8df21e&scoped=true&"
import script from "./AvatarWrapper.vue?vue&type=script&lang=js&"
export * from "./AvatarWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AvatarWrapper.vue?vue&type=style&index=0&id=cc8df21e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8df21e",
  null
  
)

export default component.exports